export default "__VITE_ASSET__CkhCahaT__"